module.exports = __webpack_public_path__ + "img/20221028111949634hve.bda641f7.png";